(() => {
  document.documentElement.classList.add('bb-js');
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Dynamic shipping dates (local calendar) ---------- */
  function fmtRange(now, start, end, locale) {
    const day = n => new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12);
    const a = day(start), b = day(Math.max(start, end));
    const opts = { month: 'short', day: 'numeric' };
    if (b.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
    const f = new Intl.DateTimeFormat(locale, opts);
    let text;
    if (start === end) text = f.format(a);
    else if (f.formatRange) text = f.formatRange(a, b);
    else text = f.format(a) + '–' + f.format(b);
    return { a, b, text };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(), loc = document.documentElement.lang || 'en-US';
    document.querySelectorAll('[data-bb-ship-date]').forEach(el => {
      const s = Number(el.dataset.start), e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      const r = fmtRange(now, s, e, loc);
      el.textContent = r.text;
      const full = new Intl.DateTimeFormat(loc, { dateStyle: 'long' });
      el.setAttribute('aria-label', s === e ? full.format(r.a) : full.format(r.a) + ' to ' + full.format(r.b));
    });
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  window.addEventListener('pageshow', updateShipDates);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateShipDates(); });

  /* ---------- Free gift: one per order while a set is in the cart, free via code ---------- */
  const Gift = (() => {
    let cfg = null, pending = null;
    const base = () => window.Shopify?.routes?.root || '/';
    async function req(path, body, tries = 2) {
      const r = await fetch(base() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
      let d;
      try { d = JSON.parse(await r.text()); } catch {
        if (tries > 1) { await new Promise(z => setTimeout(z, 500)); return req(path, body, tries - 1); }
        throw Error('Your cart is busy. Please try again in a moment.');
      }
      if (!r.ok || d.status) throw Error(d.description || d.message || 'Your cart could not be updated. Please try again.');
      return d;
    }
    async function reconcile() {
      if (!cfg || !cfg.gift) return null;
      let cart = await req('cart.js');
      const isPack = i => cfg.packs.includes(Number(i.variant_id));
      const gifts = cart.items.filter(i => Number(i.variant_id) === cfg.gift);
      const want = cart.items.some(isPack) ? 1 : 0;
      const have = gifts.reduce((n, i) => n + i.quantity, 0);
      const codes = (cart.discount_codes || []).map(d => d.code);
      const own = cfg.code.toUpperCase();
      const others = codes.filter(c => c.toUpperCase() !== own);
      const applied = codes.some(c => c.toUpperCase() === own);
      const free = gifts.every(i => i.final_line_price === 0);
      if (have === want && (want === 0 ? !applied : applied && free)) return cart;
      const updates = {};
      if (gifts.length) gifts.forEach((g, k) => { updates[g.key] = k === 0 ? want : 0; });
      else if (want) updates[cfg.gift] = want;
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(s => s.id) || [];
      cart = await req('cart/update.js', { updates, discount: [...others, ...(want ? [cfg.code] : [])].join(','), sections, sections_url: location.pathname });
      const charged = cart.items.filter(i => Number(i.variant_id) === cfg.gift && i.final_line_price > 0);
      if (want && charged.length) {
        const rm = {}; charged.forEach(i => { rm[i.key] = 0; });
        cart = await req('cart/update.js', { updates: rm, sections, sections_url: location.pathname });
        if (drawer?.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
        throw Error('Your set is in your cart, but the free gift could not be applied. Please contact us before checkout.');
      }
      if (drawer?.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
      return cart;
    }
    return { set(c) { cfg = c; }, sync() { if (!pending) pending = reconcile().finally(() => { pending = null; }); return pending; } };
  })();
  window.BitebackGift = Gift;

  /* ---------- Reveal ---------- */
  const initReveal = () => {
    const secs = document.querySelectorAll('.bb-s[data-bb-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      secs.forEach(s => io.observe(s));
    } else secs.forEach(s => s.classList.add('is-in'));
    const catchUp = () => secs.forEach(s => { if (s.getBoundingClientRect().top < innerHeight) s.classList.add('is-in'); });
    addEventListener('scroll', () => requestAnimationFrame(catchUp), { passive: true });
    catchUp();
  };

  /* ---------- Buy box ---------- */
  const init = () => {
    updateShipDates();
    initReveal();
    const root = document.querySelector('#biteback');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.bb-proof .ceyla-rproof__text').forEach(p => p.childNodes.forEach(n => { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; }));

    const money = c => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(c / 100);
    const tiers = [...root.querySelectorAll('[name="bb-tier"]')];
    const addons = [...root.querySelectorAll('[data-bb-addon]')];
    const tierInfo = t => {
      const r = tiers.find(x => x.value === String(t)) || tiers[0];
      return { r, variant: Number(r.dataset.variant), price: Number(r.dataset.price), compare: Number(r.dataset.compare || 0), media: r.dataset.media, available: r.dataset.available === 'true', includes: (r.dataset.includes || '').split(',').map(s => s.trim()).filter(Boolean) };
    };
    Gift.set({ packs: tiers.map(r => Number(r.dataset.variant)), gift: Number(root.dataset.giftVariant) || 0, code: root.dataset.giftCode || 'BITEBACKGIFT' });

    /* gallery */
    const g = root.querySelector('[data-bb-gallery]');
    const slides = [...g.querySelectorAll('.bb-slide')];
    const thumbs = [...root.querySelectorAll('.bb-thumb')];
    const smooth = () => (reduce() ? 'auto' : 'smooth');
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : g.clientWidth) || g.clientWidth;
    const idx = () => Math.max(0, Math.min(slides.length - 1, Math.round(g.scrollLeft / step())));
    const syncIdx = () => { const i = idx(); const ix = root.querySelector('[data-bb-index]'); if (ix) ix.textContent = String(i + 1); thumbs.forEach((t, j) => { t.classList.toggle('is-on', i === j); t.setAttribute('aria-pressed', String(i === j)); }); };
    const to = (i, instant) => {
      const left = Math.max(0, Math.min(slides.length - 1, i)) * step();
      g.scrollTo({ left, behavior: instant ? 'auto' : smooth() });
      setTimeout(() => { if (Math.abs(g.scrollLeft - left) > 4) g.scrollTo({ left, behavior: 'auto' }); syncIdx(); }, 700);
    };
    root.querySelectorAll('[data-bb-slide]').forEach(b => b.addEventListener('click', () => to(Number(b.dataset.bbSlide))));
    root.querySelector('[data-bb-next]')?.addEventListener('click', () => to(idx() + 1));
    root.querySelector('[data-bb-prev]')?.addEventListener('click', () => to(idx() - 1));
    let raf;
    g.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = idx();
        const ix = root.querySelector('[data-bb-index]');
        if (ix) ix.textContent = String(i + 1);
        thumbs.forEach((t, j) => { t.classList.toggle('is-on', i === j); t.setAttribute('aria-pressed', String(i === j)); });
        slides.forEach((s, j) => { const v = s.querySelector('video'); if (v) { if (i === j) v.play().catch(() => {}); else v.pause(); } });
      });
    }, { passive: true });
    g.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); to(idx() + (e.key === 'ArrowRight' ? 1 : -1)); } });

    /* offer state */
    let tier = Number(root.dataset.tier) || 2;
    const termsId = root.querySelector('[data-bb-terms-id]');
    const activeAddons = () => { const inc = tierInfo(tier).includes; return addons.filter(a => a.checked && !inc.includes(a.dataset.bbAddon)); };
    const paint = fromUser => {
      const t = tierInfo(tier);
      tiers.forEach(r => { r.checked = r.value === String(tier); r.closest('.bb-rig').classList.toggle('is-on', r.checked); });
      const box = root.querySelector('.bb-addons');
      if (box) box.classList.toggle('is-all-in', addons.length > 0 && addons.every(a => t.includes.includes(a.dataset.bbAddon)));
      addons.forEach(a => {
        const inKit = t.includes.includes(a.dataset.bbAddon);
        const row = a.closest('.bb-addon');
        row.classList.toggle('is-included', inKit);
        a.disabled = inKit;
      });
      root.querySelector('[data-bb-price]').textContent = money(t.price);
      const c = root.querySelector('[data-bb-compare]'), s = root.querySelector('[data-bb-save]');
      if (t.compare > t.price) { c.hidden = false; s.hidden = false; c.textContent = money(t.compare); s.textContent = 'Save ' + money(t.compare - t.price).replace(/\.00(?=\D*$)/, ''); }
      else { c.hidden = true; s.hidden = true; }
      const total = t.price + activeAddons().reduce((n, a) => n + Number(a.dataset.price), 0);
      document.querySelectorAll('[data-bb-atc-total]').forEach(el => { el.textContent = money(total); });
      const sp = document.querySelector('[data-bb-sticky-price]'); if (sp) sp.textContent = money(total);
      if (termsId && termsId.value !== String(t.variant)) { termsId.value = t.variant; termsId.dispatchEvent(new Event('change', { bubbles: true })); }
      const main = root.querySelector('.bb-atc[data-bb-add]'); if (main) main.disabled = !t.available;
      document.querySelectorAll('[data-bb-kit-toggle]').forEach(b => {
        const a = addons.find(x => x.dataset.bbAddon === b.dataset.bbKitToggle);
        const on = !!(a && (a.checked || t.includes.includes(a.dataset.bbAddon)));
        b.setAttribute('aria-pressed', String(on));
        const sp2 = b.querySelector('span'); if (sp2) sp2.textContent = on ? sp2.dataset.on : sp2.dataset.off;
      });
      if (fromUser) {
        if (t.variant) { const u = new URL(location.href); u.searchParams.set('variant', t.variant); history.replaceState(history.state, '', u); }
        if (t.media) { const si = slides.findIndex(sl => sl.dataset.mediaId === t.media); if (si >= 0 && root.querySelector('.bb-buy').getBoundingClientRect().top < innerHeight) to(si); }
        const card = root.querySelector('.bb-rig.is-on');
        if (card && !reduce()) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); }
      }
    };
    tiers.forEach(r => r.addEventListener('change', () => { tier = Number(r.value); paint(true); }));
    addons.forEach(a => a.addEventListener('change', () => paint(false)));
    document.querySelectorAll('[data-bb-kit-toggle]').forEach(b => b.addEventListener('click', () => {
      const a = addons.find(x => x.dataset.bbAddon === b.dataset.bbKitToggle);
      if (!a || a.disabled) return;
      a.checked = !a.checked; paint(false);
    }));
    paint(false);
    window.addEventListener('pageshow', () => paint(false));

    /* cart */
    async function drawerReady() {
      await customElements.whenDefined('cart-drawer');
      const d = document.querySelector('cart-drawer');
      if (!d || typeof d.renderContents !== 'function') throw Error('The cart is still loading. Please try again.');
      return d;
    }
    const setCount = n => root.querySelectorAll('[data-bb-count]').forEach(e => { e.textContent = n; });
    const vipFirst = () => {
      const sheet = document.querySelector('.vf-root'), bag = document.querySelector('cart-drawer');
      if (!sheet || !bag || sheet.classList.contains('open')) return;
      const hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
      Object.keys(hide).forEach(p => bag.style.setProperty(p, hide[p], 'important'));
      let ticks = 0;
      const tm = setInterval(() => { if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(p => bag.style.removeProperty(p)); } }, 100);
    };
    let busy = false;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget, t = tierInfo(tier);
      if (!t.available || !t.variant) return;
      busy = true;
      const buttons = [...document.querySelectorAll('[data-bb-add]')];
      buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const err = root.querySelector('[data-bb-error]'); err.textContent = '';
      try {
        const drawer = await drawerReady();
        drawer.setActiveElement && drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map(s => s.id);
        const items = [{ id: t.variant, quantity: 1 }];
        activeAddons().forEach(a => items.push({ id: Number(a.dataset.variant), quantity: 1 }));
        const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections, sections_url: location.pathname }) });
        let data;
        try { data = JSON.parse(await res.text()); } catch { throw Error('Your set could not be added. Please try again.'); }
        if (!res.ok || data.status) throw Error(data.description || data.message || 'Your set could not be added. Please try again.');
        vipFirst();
        drawer.renderContents(data);
        let cart;
        try { cart = await Gift.sync(); } catch (ge) { err.textContent = ge.message; }
        if (!cart) cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        setCount(cart.item_count);
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.open(btn);
      } catch (x) {
        err.textContent = x.message || 'Please check your cart before trying again.';
        err.scrollIntoView({ block: 'center', behavior: smooth() });
      } finally {
        busy = false;
        buttons.forEach(b => { b.removeAttribute('aria-busy'); b.disabled = false; });
        paint(false);
      }
    }
    document.querySelectorAll('[data-bb-add]').forEach(b => b.addEventListener('click', add));
    root.querySelectorAll('[data-bb-cart]').forEach(b => b.addEventListener('click', async () => {
      try {
        const d = await drawerReady();
        await Gift.sync();
        const ids = d.getSectionsToRender().map(s => s.id), base = window.Shopify?.routes?.root || '/';
        const [sections, c] = await Promise.all([fetch(base + '?sections=' + ids.join(',')).then(r => r.json()), fetch(base + 'cart.js').then(r => r.json())]);
        d.renderContents({ id: 0, sections });
        d.classList.toggle('is-empty', c.item_count === 0);
        setCount(c.item_count);
        d.open(b);
      } catch (x) { root.querySelector('[data-bb-error]').textContent = x.message; }
    }));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(window.__bbSync);
        window.__bbSync = setTimeout(() => Gift.sync().then(c => c && setCount(c.item_count)).catch(x => { const el = document.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-bb-error]'); if (el) el.textContent = x.message; }), 150);
      });
    }
    const nd = document.querySelector('cart-drawer');
    if (nd) new MutationObserver(() => {
      const q = [...nd.querySelectorAll('.cart-drawer-item .quantity__input')];
      if (q.length) setCount(q.reduce((n, i) => n + Number(i.value || 0), 0));
      else if (nd.classList.contains('is-empty')) setCount(0);
    }).observe(nd, { subtree: true, childList: true });
    document.addEventListener('click', e => {
      const b = e.target.closest('cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.bbReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      Gift.sync().then(() => {
        const n = document.querySelector('cart-drawer [name="checkout"]') || b;
        n.dataset.bbReady = '1'; n.click(); delete n.dataset.bbReady;
      }).catch(x => { const el = document.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-bb-error]'); if (el) el.textContent = x.message; });
    }, true);
    Gift.sync().then(c => c && setCount(c.item_count)).catch(() => {});

    /* policy dialog */
    const dlg = document.querySelector('#biteback-policy');
    if (dlg) {
      document.querySelectorAll('[data-bb-policy]').forEach(b => b.addEventListener('click', () => dlg.showModal()));
      dlg.querySelector('[data-bb-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    }
    /* sample pill */
    const cBan = document.querySelector('.bb-banner'), cPill = document.querySelector('.bb-concept-pill');
    if (cPill) {
      if (cBan && 'IntersectionObserver' in window) new IntersectionObserver(es => cPill.classList.toggle('is-on', !es[0].isIntersecting)).observe(cBan);
      else cPill.classList.add('is-on');
    }
    /* sticky bar */
    const sticky = document.querySelector('[data-bb-sticky]'), buy = root.querySelector('.bb-buy .bb-atc');
    if (sticky && buy) {
      let sraf;
      const check = () => {
        cancelAnimationFrame(sraf);
        sraf = requestAnimationFrame(() => {
          const closeBtn = document.querySelector('.bb-atc--close');
          const closeVis = closeBtn && closeBtn.getBoundingClientRect().top < innerHeight && closeBtn.getBoundingClientRect().bottom > 0;
          const show = buy.getBoundingClientRect().bottom < 0 && !closeVis;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', String(!show));
          sticky.querySelector('button').tabIndex = show ? 0 : -1;
        });
      };
      addEventListener('scroll', check, { passive: true }); addEventListener('resize', check); check();
    }
  };

  /* ---------- Size finder ---------- */
  const widgets = () => {
    document.querySelectorAll('[data-bb-finder]').forEach(f => {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      const sockets = (f.dataset.sockets || '').split('|').map(s => { const [label, mm] = s.split('@'); return { label: label.trim(), mm: Number(mm) }; }).filter(s => s.label && s.mm).sort((a, b) => a.mm - b.mm);
      const out = f.querySelector('[data-bb-answer]');
      const tabs = [...f.querySelectorAll('[data-sys]')];
      tabs.forEach(t => t.addEventListener('click', () => {
        tabs.forEach(x => { const on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
        f.querySelectorAll('[data-sizes]').forEach(p => { p.hidden = p.dataset.sizes !== t.dataset.sys; });
      }));
      const inch = s => { const [n, d] = s.split('/').map(Number); return d ? (n / d) * 25.4 : n * 25.4; };
      const answer = (mm, label) => {
        f.querySelectorAll('[data-size-in],[data-size-mm]').forEach(b => b.classList.toggle('is-on', b.dataset.sizeIn === label || b.dataset.sizeMm === label));
        const min = sockets[0], max = sockets[sockets.length - 1];
        let html;
        if (mm > max.mm + 0.6) html = '<b>Bigger than 3/4 in.</b><span>' + (f.dataset.big || '') + '</span>';
        else if (mm < min.mm - 0.4) html = '<b>Smaller than 1/4 in.</b><span>' + (f.dataset.small || '') + '</span>';
        else {
          const exact = sockets.find(s => Math.abs(s.mm - mm) <= 0.4);
          const down = [...sockets].reverse().find(s => s.mm < (exact ? exact.mm : mm) - 0.2);
          if (exact) html = '<b>Grab the ' + exact.label + ' socket.</b><span>' + (f.dataset.exact || '') + (down ? ' Spins? Drop to the <strong>' + down.label + '</strong>.' : '') + '</span>';
          else {
            const pick = [...sockets].reverse().find(s => s.mm < mm) || min;
            html = '<b>Grab the ' + pick.label + ' socket.</b><span>' + (f.dataset.down || '') + '</span>';
          }
        }
        out.innerHTML = html;
        out.classList.remove('is-new'); void out.offsetWidth; out.classList.add('is-new');
      };
      f.querySelectorAll('[data-size-in]').forEach(b => b.addEventListener('click', () => answer(inch(b.dataset.sizeIn), b.dataset.sizeIn)));
      f.querySelectorAll('[data-size-mm]').forEach(b => b.addEventListener('click', () => answer(Number(b.dataset.sizeMm), b.dataset.sizeMm)));
    });
  };

  const boot = () => { init(); widgets(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => { updateShipDates(); widgets(); document.querySelectorAll('.bb-s[data-bb-reveal]').forEach(s => s.classList.add('is-in')); });
})();
